import api from './../api';

export interface Contrato {
  id: string;
  numero: number;
  status: string;
  statusCodigo: number;
  dataHoraPrimeiraAtivacao?: Date;
  situacao: boolean;
  fornecedor: string;
  objetoResumido: string;
  possuiDocumentacaoAcessoria: boolean;
  possuiSegurosGarantias: boolean;
  possuiDocumentoSeguroGarantiaCadastrado: boolean;
  possuiDocumentacaoAcessoriaMensalCadastrada: boolean;
}

export const getAllContratos = () => api.get<Contrato[]>('contratos');